import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export interface ByRequestOnlyConfirmDialogProps {
  /** The Rx being changed, or null when closed. */
  rxNumber: string | null;
  /** Whether the change turns By request only on. */
  turningOn: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * PRX-137 review (M3): "By request only" through the billing-queue PRN route
 * recomputes the basket's next follow-up date, so it moves when the
 * subscription is next billed. Asked before it is sent.
 */
export const ByRequestOnlyConfirmDialog: React.FC<ByRequestOnlyConfirmDialogProps> = ({
  rxNumber,
  turningOn,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={rxNumber !== null} onClose={onCancel} aria-labelledby="by-request-only-confirm-title" maxWidth="xs">
    <DialogTitle id="by-request-only-confirm-title">Change By request only</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {turningOn ? `Rx ${rxNumber} will only be sent when asked for.` : `Rx ${rxNumber} will go back on the schedule.`}{' '}
        This changes when the subscription is next billed. Continue?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" onClick={onConfirm}>
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);

export default ByRequestOnlyConfirmDialog;
